import {BookingSummaryOracle} from "./Oracle/Booking/BookingSummaryOracle";
import {BookingTableOracle} from "./Oracle/Booking/BookingTableOracle";
import {FormCancelBookingOracle} from "./Oracle/Form/FormCancelBookingOracle";
import {BookingDivOracle} from "./Oracle/Booking/BookingDivOracle";
import {Accordion} from "./bootstrap/Accordion";
import {FormInvoice} from "./Oracle/Form/FormInvoice";
import {Validate} from "./bootstrap/Validate";
import {FormBenefits} from "./Oracle/Form/FormBenefits";
import {BookingCalculate} from "./Oracle/Booking/BookingCalculate";
import {BookingScroll} from "./Oracle/Booking/BookingScroll";

(function ($) {
    let bookingSummaryOracle = new BookingSummaryOracle();
    let bookingTableOracle = new BookingTableOracle();
    let bookingDivOracle = new BookingDivOracle();
    new BookingScroll();

    new FormCancelBookingOracle();

    actionAfterAjax();

    $('#selectBookingCourt').select2();

    var dzisiaj = rez_Dzisiaj()

    function rez_Dzisiaj() {
        var data = new Date();
        var rok = data.getFullYear();
        var mies = data.getMonth() + 1;
        var dzien = data.getDate();
        mies = mies < 10 ? '0' + mies : mies;
        dzien = dzien < 10 ? '0' + dzien : dzien;
        return rok + '-' + mies + '-' + dzien;
    }

    function ZmianaObiektu(obiekt_typ) {
        let name = obiekt_typ;
        if (name === 'pingpong') {
            name = 'tenisa stołowego';
        }

        if (name === 'squash') {
            name = 'squasha';
        }

        if (name === 'badminton') {
            name = 'badmintona';
        }


        $('#navCourtName').html(name);


        if (document.body.offsetWidth < 768){
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.bookingNav').offset().top,
            }, 250);
        }

        ShowRezerwacjeTable();
    }

    $('#rez_obiekt_typ_s').click(function () {
        var obiekt_typ = $(this).data('obiekt_typ');
        $('#rez_obiekt_typ').val(obiekt_typ);
        window.history.pushState("", "", `/rezerwacje/?type=${obiekt_typ}`);
        ZmianaObiektu(obiekt_typ);
    });
    $('#rez_obiekt_typ_b').click(function () {
        var obiekt_typ = $(this).data('obiekt_typ');
        $('#rez_obiekt_typ').val(obiekt_typ);
        window.history.pushState("", "", `/rezerwacje/?type=${obiekt_typ}`);
        ZmianaObiektu(obiekt_typ);
    });
    $('#rez_obiekt_typ_t').click(function () {
        var obiekt_typ = $(this).data('obiekt_typ');
        $('#rez_obiekt_typ').val(obiekt_typ);
        window.history.pushState("", "", `/rezerwacje/?type=${obiekt_typ}`);
        ZmianaObiektu(obiekt_typ);
    });

    $('#b_twoje_rezerwacje').click(function () {
        $.ajax({
            type: "POST",
            url: ajax_options.admin_ajax_url,
            data: {
                operacja: 'ShowTwojeRezerwacje',
                action: 'ShowTwojeRezerwacje'
            },
            success: function (msg) {
                if (msg != '') {
                    //$('#div_rez').html(msg);
                    $('#rez_rezerwacje_div').html(msg);
                }
            },
            error: function (error) {
                alert('Blad 1');
            }
        });
    });
    $('#rez_data_m_b').click(function () {
        var data = $('#rez_data').val();
        data = next_day(data, -1);
        if (data >= dzisiaj) {
            $("#rez_data").datepicker("setDate", data);
            ShowRezerwacjeTable(data);
        }
    });
    $('#rez_data_m7_b').click(function () {
        var data = $('#rez_data').val();
        data = next_day(data, -7);
        if (data >= dzisiaj) {
            $("#rez_data").datepicker("setDate", data);
            ShowRezerwacjeTable(data);
        }
    });
    $('#rez_data_p_b').click(function () {
        var data = $('#rez_data').val();
        data = next_day(data, 1);
        $("#rez_data").datepicker("setDate", data);
        ShowRezerwacjeTable(data);
    });
    $('#rez_data_p7_b').click(function () {
        var data = $('#rez_data').val();
        data = next_day(data, 7);
        $("#rez_data").datepicker("setDate", data);
        ShowRezerwacjeTable(data);
    });
    $('#rez_do_7_16_b').click(function () {
        var data = $('#rez_data').val();
        var godz_od = '06:00';
        var godz_do = '15:00';
        ShowRezerwacjeTable(data, godz_od, godz_do);
    });
    $('#rez_od_15_24_b').click(function () {
        var data = $('#rez_data').val();
        var godz_od = '15:00';
        var godz_do = '00:00';
        ShowRezerwacjeTable(data, godz_od, godz_do);
    });
    $('#rez_od_11_20_b').click(function () {
        var data = $('#rez_data').val();
        var godz_od = '11:00';
        var godz_do = '20:00';
        ShowRezerwacjeTable(data, godz_od, godz_do);
    });
    $('#rez_rezerwuj_b').click(function () {
        RezerwujWybraneShow();
    });
    $('#rez_odwolaj_b').click(function () {
        OdwolajWybraneShow();
    });
    $('#rez_lista_rezerwowa_b').click(function () {
        ListaRezerwowaWybraneShow();
    });
    //---------------------------------------------------------------------------
    LigiZapisyKolejki_init();

//---------------------------------------------------------------------------
    function FitGrafikShow_init() {
        $('.rez_fit_div').click(function () {
//        if ($('#rez_klie_nick_4datepicker').val()=='')  {
//            $('#rez_info').html($('#rez_info_no_login').val());
//            $('#rez_info').slideDown( 1000 ).delay(3000).slideUp(1000);
//            $('#user_login').focus();
//        }
//        else {
            var even_id = $(this).data('even_id');
            FitRezerwujWybraneShow(even_id);
//        }
        });
    }

    FitGrafikShow_init();

    function Data2Text(data) {
        var rok = data.getFullYear();
        var mies = data.getMonth() + 1;
        var dzien = data.getDate();
        mies = mies < 10 ? '0' + mies : mies;
        dzien = dzien < 10 ? '0' + dzien : dzien;
        return rok + '-' + mies + '-' + dzien;
    }

    var freeDays = [];
    var abc = {};

    function fetchFreeDays(year, month) {
        var wp_klie_nick = $('#rez_klie_nick_4datepicker').val();
        if (year != undefined && month != undefined) {
            var date = new Date(year, month);
            var firstDay = new Date(date.getFullYear(), date.getMonth() - 2, 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            var fd = Data2Text(firstDay);
            var ld = Data2Text(lastDay);

        } else {
            var fd = '';
            var ld = '';
        }
        if (wp_klie_nick != '') {
            $.ajax({
                type: "POST",
                dataType: "json",
                //async: false,
                url: ajax_options.admin_ajax_url,
                data: {
                    action: 'Rezerwacje4Datepicker',
                    klie_nick: wp_klie_nick,
                    data_od: fd,
                    data_do: ld
                },
                success: function (msg) {
                    abc = {};
                    $.each(msg, function (index, value) {
                        //freeDays.push(value.freeDate); // add this date to the freeDays array
//                      alert(value.data+' '+value.opis);
                        abc[value.data] = value.opis;
                    });
                    $("#rez_data").datepicker("refresh");
                }
//              error:    function(error) {
//                alert('Blad 2');
//              }
            });
        }
    }

    $(function () {
//    $.datepicker.setDefaults( $.datepicker.regional[ "pl" ] );
        var dotyczy = $('#rez_dotyczy').val();
        if (dotyczy == 'ligi_zapisy') {

        } else {
            fetchFreeDays();
            if ($('#refresh_4datepicker').val() == 'fitness') {

                $(".rangeDate__body-inner").click(function () {
                    $('#rez_data').datepicker().datepicker("show")
                });

                //----------------------------------------------------------------------
                $("#rez_data").datepicker(
                    {
                        dateFormat: 'yy-mm-dd',
                        defaultDate: '16-05-16',
                        regional: "pl",
                        minDate: 0,
                        maxDate: '+2w',
                        numberOfMonths: 1,
                        firstDay: 1,
                        showOtherMonths: true,
                        selectOtherMonths: true,
                        altField: "#rez_wybrana_data_hid",
                        altFormat: "DD, d MM, yy",
                        onSelect: function (dateText, inst) {
                            if ($('#refresh_4datepicker').val() == 'fitness') {
                                FitGrafikShow(dateText);
                            } else {
                                ShowRezerwacjeTable(dateText, '', '');
                            }
                        },
                        beforeShow: function () {
                            $(".ui-datepicker").css('font-size', 9);
                        },
                        beforeShowDay: function (date) {
                            //            $.datepicker.noWeekends;
                            var day = date.getDay();
                            var Highlight = abc[Data2Text(date)];
                            if (Highlight) {
                                //                if ($('#rez_dotycz').val()=='fitness')  {
                                //                    return [(day != 0 && day != 6), "Highlighted", Highlight];
                                //                }
                                //                else {
                                return [true, "Highlighted", Highlight];
                                //                }
                            } else {
                                if ($('#refresh_4datepicker').val() == 'fitness') {
                                    return [(day != 0 && day != 6), ''];
                                } else {
                                    return [true, '', ''];
                                }
                            }
                        }
                    }
                );
                //----------------------------------------------------------------------
            } else {
                //----------------------------------------------------------------------

                $(".rangeDate__body-inner").click(function () {
                    $('#rez_data').datepicker().datepicker("show")
                });
                $("#rez_data").datepicker(
                    {
                        dateFormat: 'yy-mm-dd',
                        regional: "pl",
                        minDate: 0,
                        maxDate: '+3m',
                        numberOfMonths: 1,
                        firstDay: 1,
                        showOtherMonths: true,
                        selectOtherMonths: true,
                        altField: "#rez_wybrana_data_hid",
                        altFormat: "DD, d MM, yy",
                        onSelect: function (dateText, inst) {
                            if ($('#refresh_4datepicker').val() == 'fitness') {
                                FitGrafikShow(dateText);
                            } else {
                                ShowRezerwacjeTable(dateText, '', '');
                            }
                        },
                        beforeShow: function () {
                            $("#ui-datepicker-div").css({});
                            $(".ui-datepicker").css('font-size', 9);
                        },
                        beforeShowDay: function (date) {
                            //            $.datepicker.noWeekends;
                            var day = date.getDay();
                            var Highlight = abc[Data2Text(date)];
                            if (Highlight) {
                                //                if ($('#rez_dotycz').val()=='fitness')  {
                                //                    return [(day != 0 && day != 6), "Highlighted", Highlight];
                                //                }
                                //                else {
                                return [true, "Highlighted", Highlight];
                                //                }
                            } else {
                                if ($('#refresh_4datepicker').val() == 'fitness') {
                                    return [(day != 0 && day != 6), ''];
                                } else {
                                    return [true, '', ''];
                                }
                            }
                        }
                    }
                );

                //----------------------------------------------------------------------
            }
            //$( "#rez_data" ).datepicker( "option", "defaultDate", +7 );
        }
        //alert(1);
        //$('#rez_ligi_ListaLig').selectmenu();
        //alert(2);
        /*    $( "#radio" ).buttonset();
            $( "#rez_obiekt_typ_div" ).buttonset();*/
        $("#rez_ligi_zapisy_kolejki_rd_div").buttonsetv();
        $("#rez_ligi_zapisy_kolejki_rd_div2").buttonsetv();

        //$( "rez_bu" ).button();
        $("button.rez_bu").click(function (event) {
            event.preventDefault();
        });

        $('#rez_wybrana_data').val($('#rez_wybrana_data_hid').val());

    });

    function rez_init() {
        $.datepicker.setDefaults($.datepicker.regional["pl"]);
        alert(1111);
        $("#rez_data").datepicker("refresh");
        alert(2);
//    $( "#rez_data" ).datepicker( "setDate", "14-10-23" );
    }

    function RezerwujWybraneShow_init() {
        bookingSummaryOracle.prevButton().addEventListener('click', () => {
            bookingTableOracle.show();
            bookingSummaryOracle.cleanBookingSummary();
        });
        new Accordion();

        $('#rez_anuluj_b').click(() => {
            ShowRezerwacjeTable();
        });
        $('#rez_potwierdz_re_b').click(function (e) {
            RezerwujWybraneZapisz();
        });
    }

    function OdwolajWybraneShow_init() {
        $('#rez_anuluj_b').click(function () {
            ShowRezerwacjeTable();
        });
        $('#rez_potwierdz_od_b').click(function () {
            OdwolajWybraneZapisz();
        });
    }

    function ListaRezerwowaWybraneShow_init() {
        $('#rez_anuluj_b').click(function () {

            ShowRezerwacjeTable();
        });
        $('#rez_potwierdz_lr_b').click(function () {
            ListaRezerwowaWybraneZapisz();
        });
    }

    function RezerwujWybraneShow() {
        if ($('#rez_klie_nick_4datepicker').val() == '') {
            $('#rez_info').html($('#rez_info_no_login').val());
            $('#rez_info').slideDown(1000).delay(3000).slideUp(1000);
            $('#user_login').focus();
        } else {
            var data = $('#rez_data').val();
            var REZ = new Array();
            var tmp;
            var jj = 0;
            $(':checkbox:checked').each(function (i) {
                if ($(this).parent().hasClass('rez_wolne')) {
                    REZ[jj] = $(this).data('obie_id') + '_' + $(this).data('godz_od') + '_' + $(this).data('godz_do');
                    jj = (jj + 1);

                }
            });
            if (REZ == '') {
            } else {
                $.ajax({
                    type: "POST",
                    url: ajax_options.admin_ajax_url,
                    data: {
                        action: 'RezerwujWybraneShow',
                        data: data,
                        REZ: REZ
                    },
                    success: function (msg) {
                        //$('#rez_rezerwacje_div').html(msg);
                        bookingTableOracle.hide();
                        bookingSummaryOracle.showBookingSummary(msg);
                        RezerwujWybraneShow_init();
                        new BookingCalculate();
                        $('#paymentSelect').select2();
                    },
                    error: function (error) {
                        alert('Blad 3');
                    }
                });
            }
        }
    }

    function OdwolajWybraneShow() {
        var data = $('#rez_data').val();
        var data = $('#rez_data').val();
        var REZ = [];
        var j = 0;
        $(':checkbox:checked').each(function (i) {
            if ($(this).parent().hasClass('rez_wlasne')) {
                REZ[j] = $(this).data('obie_id') + '_' + $(this).data('godz_od') + '_' + $(this).data('godz_do');
                j = (j + 1);
            }
        });
        if (REZ == '') {
        } else {
            $.ajax({
                type: "POST",
                url: ajax_options.admin_ajax_url,
                data: {
                    action: 'OdwolajWybraneShow',
                    data: data,
                    REZ: REZ
                },
                success: function (msg) {
                    $('#rez_rezerwacje_div').html(msg);
                    OdwolajWybraneShow_init();
                    init();
                },
                error: function (error) {
                    alert('Blad 4');
                }
            });
        }
    }

    function ListaRezerwowaWybraneShow() {
        var data = $('#rez_data').val();
        var REZ = [];
        var j = 0;
        $(':checkbox:checked').each(function (i) {
            if ($(this).parent().hasClass('rez_zajete')) {
                REZ[j] = $(this).parent().parent().data('obie_id') + '_' + $(this).data('godz_od') + '_' + $(this).data('godz_do');
                j = (j + 1);
            }
        });
        if (REZ == '') {
        } else {
            $.ajax({
                type: "POST",
                url: ajax_options.admin_ajax_url,
                data: {
                    action: 'ListaRezerwowaWybraneShow',
                    data: data,
                    REZ: REZ
                },
                success: function (msg) {
                    $('#rez_rezerwacje_div').html(msg);
                    ListaRezerwowaWybraneShow_init();
                },
                error: function (error) {
                    alert('Blad 5');
                }
            });
        }
    }

    function RezerwujWybraneZapisz() {
        let formBenefits = new FormBenefits();
        let formInvoice = new FormInvoice();
        let dataInvoice = null;


        if (formInvoice.isPaymentInvoice()) {
            let typeForm = $('input[name=type]:checked', '#formInvoice').val();
            if (typeForm === 'P') {
                $('#nip').val('brak');
            }

            let validate = new Validate('#formInvoice');


            if (validate.isOkey) {
                dataInvoice = formInvoice.data;
            } else {
                return;
            }
        }

        if (formBenefits.isActivated()) {
            let validate = new Validate('#formBenefits');
            if (validate.isOkey) {
                formBenefits = formBenefits.data;
            } else {
                return;
            }
        }

        let paymentSelect = parseInt($('#paymentSelect').val());
        if (isNaN(paymentSelect)) {
            paymentSelect = 2;
        }
        if (paymentSelect === 2) {
            paymentSelect = 2; // full payment
        } else {
            paymentSelect = 1; // required payment
        }


        var REZ = [];
        var j = 0;
        var data = $('#rez_data').val();
        $('.rez_wybrane_re_li').each(function (i) {
            REZ[j] = $(this).attr('id');
            j = (j + 1);
        });
        if (REZ == '') {

        } else {
            $.ajax({
                type: "POST",
                url: ajax_options.admin_ajax_url,
                data: {
                    action: 'RezerwujWybraneZapisz',
                    data: data,
                    REZ: REZ,
                    dataInvoice: dataInvoice,
                    paymentSelect: paymentSelect,
                    countBenefits: $('#benefits').val(),
                },
                beforeSend: function () {
                    bookingDivOracle.addLoading();
                    bookingSummaryOracle.addLoading();
                    $('#rez_rezerwacje_div').addClass('bookingCourt--loading');
                },
                success: function (msg) {
                    fetchFreeDays();
                    if (msg) {
                        if (msg.includes('id="payLaneForm"')) {
                            $('#rez_rezerwacje_div').after(msg);
                            $('#div_rez').find('#payLaneForm').submit();
                        } else {
                            let div = $('#rez_rezerwacje_div');
                            div.html(msg);
                            bookingDivOracle.removeLoading();
                            bookingSummaryOracle.removeLoading();
                            div.removeClass('bookingCourt--loading');
                            div.fadeIn();
                        }
                    } else {
                        ShowRezerwacjeTable(data);
                    }
                },
                error: function (error) {
                    alert('Blad 6');
                }
            });
        }
    }

    function OdwolajWybraneZapisz() {
        var REZ = [];
        var j = 0;
        var data = $('#rez_data').val();
        $('.rez_wybrane_od_li').each(function (i) {
            REZ[j] = $(this).attr('id');
            j = (j + 1);
        });
        if (REZ == '') {
        } else {
            $.ajax({
                type: "POST",
                url: ajax_options.admin_ajax_url,
                data: {
                    action: 'OdwolajWybraneZapisz',
                    data: data,
                    REZ: REZ
                },
                success: function (msg) {
                    fetchFreeDays();
                    if (msg != '') {
                        $('#rez_rezerwacje_div').html(msg);
                    } else {
                        ShowRezerwacjeTable(data);
                    }
                    //RezerwujWybraneShow_init();
                },
                error: function (error) {
                    alert('Blad 7');
                }
            });
        }
    }

    function ShowRezerwacjeTable(data, godz_od, godz_do) {
//      alert(11);
        if (typeof (data) === 'undefined') data = $('#rez_data').val();
        if (typeof (godz_od) === 'undefined') godz_od = '';
        if (typeof (godz_do) === 'undefined') godz_do = '';
        var obiekt_typ = $('#rez_obiekt_typ').val();
        if (obiekt_typ === 'pingpong') {
            obiekt_typ = 'tenis';
        }
        $.ajax({
            type: "POST",
            url: ajax_options.admin_ajax_url,
            data: {
                operacja: 'ShowRezerwacjeTable',
                action: 'ShowRezerwacjeTable',
                data: data,
                obiekt_typ: obiekt_typ,
                godz_od: godz_od,
                godz_do: godz_do
            },
            beforeSend: function () {
                $('#rez_rezerwacje_div').addClass('bookingCourt--loading');
                bookingSummaryOracle.addLoading();
            },
            success: function (msg) {
                if (msg != '') {
                    $('#rez_wybrana_data').val($('#rez_wybrana_data_hid').val());
                    $('#rez_data').val(data);
                    $('#rez_rezerwacje_div').removeClass('bookingCourt--loading');
                    $('#rez_rezerwacje_div').html(msg);
                    bookingDivOracle.removeLoading();
                    bookingSummaryOracle
                        .removeLoading()
                        .cleanBookingSummary();
                    bookingTableOracle.show();
                    actionAfterAjax();
                    $('#currentBalanceView').html($('#currentBalance').val());
                }
                if (obiekt_typ == 'squash') {
                    jQuery("#footer").css('position', 'static');
                } else {
                    jQuery("#footer").css('position', 'absolute');
                }
                init();
            },
            error: function (error) {
                alert('Blad 8');
            }
        });
    }

    function ListaRezerwowaWybraneZapisz() {
        var REZ = [];
        var j = 0;
        var data = $('#rez_data').val();
        $('.rez_wybrane_re_li').each(function (i) {
            REZ[j] = $(this).attr('id');
            j = (j + 1);
        });
        if (REZ == '') {
        } else {
            $.ajax({
                type: "POST",
                url: ajax_options.admin_ajax_url,
                data: {
                    action: 'ListaRezerwowaWybraneZapisz',
                    data: data,
                    REZ: REZ
                },
                success: function (msg) {
                    ShowRezerwacjeTable(data);
                },
                error: function (error) {
                    alert('Blad 9');
                }
            });
        }
    }

    function next_day(data, step) {

        var tab = data.split("-");

        var year = tab[0];
        var month = tab[1];
        var day = tab[2];
        var date = new Date(year, month - 1, day);

        var now = date;
        now.setDate(now.getDate() + step);
        var year = now.getFullYear();
        var month = now.getMonth() + 1;
        var day = now.getDate();

        month = "0" + month;
        month = month.substring(month.length - 2, month.length);

        day = "0" + day;
        day = day.substring(day.length - 2, day.length);

        return year + "-" + month + "-" + day;
    }

//--ligi------------------------------------------------------------------------
    $('#rez_ligi_ListaDyscyplin').select2().on('select2:select', function (e) {
        var dotyczy = $('#rez_dotyczy').val();
        var dyscyplina = $(this).val();
        ligi_ListaLigShow(dotyczy, dyscyplina);
    });
//  function ligi_KoleID()
//  {
//    $('.rez_ligi_zapisy_kolejki_td:checked').data('kole-id')
//  }
    function ligi_ListaLigShow(dotyczy, dyscyplina) {
        $.ajax({
            type: "POST",
            url: ajax_options.admin_ajax_url,
            data: {
                action: 'Ligi_ListaLig',
                dyscyplina: dyscyplina,
                dotyczy: dotyczy
            },
            success: function (msg) {
                $('#rez_ligi_ListaLig').html(msg);
                var liga_id = $('#rez_ligi_ListaLig').val();
                var kole_id = '';
                if (dotyczy == 'ligi_zapisy') {
                    LigiZapisyKolejkiShow(kole_id, liga_id);
                    //             LigiZapisyShow(kole_id,liga_id);
                } else if (dotyczy == 'ligi_ranking') {
                    LigiRankingShow(liga_id);
                } else {
                    //LigiWynikiShow(kole_id);
                    ligi_ListaKolejekShow(dotyczy, liga_id);
                }
            },
            error: function (error) {
                alert('Blad 10');
            }
        });
    }

    function ligi_ListaKolejekShow(dotyczy, liga_id) {
        var kole_id = '';
        $.ajax({
            type: "POST",
            url: ajax_options.admin_ajax_url,
            data: {
                action: 'Ligi_ListaKolejek',
                liga_id: liga_id,
                dotyczy: dotyczy
            },
            success: function (msg) {
                $('#rez_ligi_ListaKolejek').html(msg);
                if (dotyczy == 'ligi_zapisy') {
                    LigiZapisyKolejkiShow(kole_id, liga_id);
                    //LigiZapisyShow(kole_id,liga_id);
                } else {
                    var kole_id = $('#rez_ligi_ListaKolejek').val();
                    LigiWynikiShow(kole_id);
                }
            },
            error: function (error) {
                alert('Blad 11');
            }
        });
    }

    $('#rez_ligi_ListaKolejek').select2().on('select2:select', function (e) {
        var kole_id = $(this).val();
        var dotyczy = $('#rez_dotyczy').val();
        if (dotyczy == 'ligi_zapisy') {
            var liga_id = $('#rez_ligi_ListaLig').val();
            LigiZapisyKolejkiShow(kole_id, liga_id);
            //LigiZapisyShow(kole_id,liga_id);
        } else {
            LigiWynikiShow(kole_id);
        }
    });


    $('#rez_ligi_ListaLig').select2().on('select2:select', function (e) {
        var dotyczy = $('#rez_dotyczy').val();
        var liga_id = $(this).val();
        if (dotyczy == 'ligi_ranking') {
            LigiRankingShow(liga_id);
        } else {
            ligi_ListaKolejekShow(dotyczy, liga_id);
        }
    });


    function LigiWynikiShow(kole_id) {
        $.ajax({
            type: "POST",
            url: ajax_options.admin_ajax_url,
            data: {
                action: 'LigiWynikiShow',
                kole_id: kole_id
            },
            beforeSend: function () {
                $('#rez_ligi_wyniki_div').addClass('bookingCourt--loading');
            },
            success: function (msg) {
                $('#rez_ligi_wyniki_div').removeClass('bookingCourt--loading');
                $('#rez_ligi_wyniki_div').html(msg);
                jQuery("#footer").css('position', 'static');
                init();
            },
            error: function (error) {
                alert('Blad 12');
            }
        });
    }

    function LigiZapisyShow(kole_id, liga_id) {
        $('#rez_ligi_zapisy_div').html('');
        $.ajax({
            type: "POST",
            url: ajax_options.admin_ajax_url,
            data: {
                action: 'LigiZapisyShow',
                kole_id: kole_id,
                liga_id: liga_id
            },
            success: function (msg) {
                $('#rez_ligi_zapisy_div').html(msg);
                jQuery("#footer").css('position', 'static');
            },
            error: function (error) {
                alert('Blad 13');
            }
        });
    }

    function LigiRankingShow(liga_id) {
        $.ajax({
            type: "POST",
            url: ajax_options.admin_ajax_url,
            data: {
                action: 'LigiRankingShow',
                liga_id: liga_id
            },
            beforeSend: function () {
                $('#rez_ligi_ranking_div').addClass('bookingCourt--loading');
            },
            success: function (msg) {
                $('#rez_ligi_ranking_div').removeClass('bookingCourt--loading');
                $('#rez_ligi_ranking_div').html(msg);
                jQuery("#footer").css('position', 'static');
            },
            error: function (error) {
                alert('Blad 14 ');
            }
        });
    }

    function LigiZapisyKolejkiShow(kole_id, liga_id) {
        //$('#rez_ligi_zapisy_kolejki_div').html('');
        $.ajax({
            type: "POST",
            url: ajax_options.admin_ajax_url,
            data: {
                action: 'LigiZapisyKolejkiShow',
                kole_id: kole_id,
                liga_id: liga_id
            },
            success: function (msg) {
                $('#rez_ligi_zapisy_kolejki_div').html(msg);
                LigiZapisyKolejki_init();
                $("#rez_ligi_zapisy_kolejki_rd_div").buttonsetv();
                $("#rez_ligi_zapisy_kolejki_rd_div2").buttonsetv();
                $('.rez_ligi_zapisy_kolejki_td:checked').each(function (i) {
                    kole_id = $(this).data('kole_id');
                });
                LigiZapisyShow(kole_id, liga_id);
            },
            error: function (error) {
                alert('Blad 15');
            }
        });
    }

    function LigiZapisyKolejki_init() {

        $('.rez_ligi_zapisy_kole').change(function (event) {
            if ($('#rez_klie_nick_4datepicker').val() == '') {
                if ($(this).attr('checked') == "checked") {
                    $(this).removeAttr('checked');
                }
//                else  {
//                    $(this).attr('checked', 'checked');
//                }
                $('#rez_info').html($('#rez_info_no_login').val());
                $('#rez_info').slideDown(1000).delay(3000).slideUp(1000);
                $('#user_login').focus();
                event.stopPropagation();
                event.preventDefault();
            } else {
                var kole_id = $(this).data('kole_id');
                var liga_id = $('#rez_ligi_ListaLig').val();
                $('#rez_ligi_ListaKolejek').val(kole_id);
                if ($(this).is(":checked")) {
                    var oper = 'dodaj';
                } else {
                    var oper = 'usun';
                }
                LigiZapisyZapisz(liga_id, kole_id, oper);
            }
            //event.stopPropagation();
            //event.preventDefault();
        });
        $('.rez_ligi_zapisy_kolejki_td').click(function () {
            var kole_id = $(this).data('kole_id');
            var liga_id = $('#rez_ligi_ListaLig').val();
            //$('#rez_ligi_ListaKolejek').val(kole_id);
            //LigiZapisyKolejkiShow(kole_id,liga_id);
            LigiZapisyShow(kole_id, liga_id);
        });
    }

    function LigiZapisyZapisz(liga_id, kole_id, oper) {
        var klie_nick = $('#rez_klie_nick_4datepicker').val();
        if (oper == 'dodaj') {
            var oper_label = '<span class="ui-button-text"> &#10004; </span>';
        } else {
            var oper_label = '<span class="ui-button-text"> - </span>';
        }
        $.ajax({
            type: "POST",
            url: ajax_options.admin_ajax_url,
            data: {
                action: 'LigiZapisyZapisz',
                liga_id: liga_id,
                kole_id: kole_id,
                klie_nick: klie_nick,
                oper: oper
            },
            success: function (msg) {
                //LigiZapisyKolejkiShow(kole_id,liga_id);
                //$('rez_kole_id_c_'+$kole_id);
                //alert($("label[for='"+'rez_kole_id_c_'+kole_id+"']").html());
                $("label[for='" + 'rez_kole_id_c_' + kole_id + "']").html(oper_label);
                LigiZapisyShow(kole_id, liga_id);
            },
            error: function (error) {
                alert('Blad 16');
            }
        });
    }

//--fit-------------------------------------------------------------------------
    function FitRezerwujWybraneShow(even_id) {
//    alert(even_id);
        $.ajax({
            type: "POST",
            url: ajax_options.admin_ajax_url,
            data: {
                action: 'FitRezerwujWybraneShow',
                even_id: even_id
            },
            success: function (msg) {
                if (msg != '') {
                    $('#rez_fit_grafik').html(msg)
                }
//           else {
//               ShowRezerwacjeTable(data);
//           }
                FitRezerwujWybraneShow_init();
            },
            error: function (error) {
                alert('Blad 17');
            }
        });

    }

    function FitGrafikShow(data) {
        if (typeof (data) === 'undefined') data = $('#rez_data').datepicker({dateFormat: 'dd-mm-yy'}).val();
        var dotyczy = $('#rez_dotyczy').val();

        $.ajax({
            type: "POST",
            url: ajax_options.admin_ajax_url,
            data: {
                operacja: 'FitGrafikShow',
                action: 'FitGrafikShow',
                data: data,
                dotyczy: dotyczy
            },
            beforeSend: function () {
                $('#rez_fit_grafik').addClass('bookingCourt--loading');
            },
            success: function (msg) {
                $('.bookingCourt--loading').removeClass('bookingCourt--loading');
                $('#rez_fit_grafik').html(msg);
                FitGrafikShow_init();
            },
            error: function (error) {
                alert('Blad 18');
            }
        });
    }

    function FitRezerwujWybraneShow_init() {

        $('#rez_fit_anuluj_b').click(function () {
            FitGrafikShow();
        });
        $('#rez_fit_potwierdz_b').click(function () {
            if ($('#rez_klie_nick_4datepicker').val() == '') {
                $('#rez_info').html($('#rez_info_no_login').val());
                $('#rez_info').slideDown(1000).delay(3000).slideUp(1000);
                $('#user_login').focus();
            } else {
                FitRezerwujWybraneZapisz();
            }
        });
        $('.rez_fit_terminy').change(function () {
            if ($('#rez_klie_nick_4datepicker').val() == '') {
                if ($(this).attr('checked') == "checked")
                    $(this).removeAttr('checked');
                else
                    $(this).attr('checked', 'checked');
                $('#rez_info').html($('#rez_info_no_login').val());
                $('#rez_info').slideDown(1000).delay(3000).slideUp(1000);
                $('#user_login').focus();
            }
        });
    }

    function FitRezerwujWybraneZapisz() {
        var REZ_INS = [];
        var REZ_DEL = [];
        var n = 0;
        var d = 0;

        $('.rez_fit_terminy').each(function (i) {
            var id = $(this).attr('id');
            var bylo = $(this).data('bylo');
            if (bylo == 'checked') {
                bylo = 1;
            } else {
                bylo = 0;
            }

            let jest = $(this).is(':checked');
            if (jest) {
                jest = 1;
            } else {
                jest = 0;
            }
            if (bylo == 0 && jest == 1) {
                REZ_INS[n] = id;
                n = (n + 1);
            } else if (bylo == 1 && jest == 0) {
                REZ_DEL[d] = id;
                d = (d + 1);
            }
        });
        if (REZ_INS !== '' || REZ_DEL !== '') {
            $.ajax({
                type: "POST",
                url: ajax_options.admin_ajax_url,
                data: {
                    action: 'FitRezerwujWybraneZapisz',
                    REZ_INS: REZ_INS,
                    REZ_DEL: REZ_DEL
                },
                success: function (msg) {
                    //alert(msg);
                    fetchFreeDays();
                    FitGrafikShow();
                },
                error: function (error) {
                    alert('Blad 19');
                }
            });
        }
    }

//------------------------------------------------------------------------------
    $.fn.buttonsetv = function () {
        /*  $(':radio, :checkbox', this).wrap('<div style="margin: 1px"/>');
          /!*$(this).buttonset();*!/
          $('label:first', this).removeClass('ui-corner-left').addClass('ui-corner-top');
          $('label:last', this).removeClass('ui-corner-right').addClass('ui-corner-bottom');
          mw = 0; // max witdh
          $('label', this).each(function(index){
             w = $(this).width();
             if (w > mw) mw = w;
          })
          $('label', this).each(function(index){
            $(this).width(mw);
          })*/
    };

//------------------------------------------------------------------------------
    function actionAfterAjax() {
        let lengthCourt = $(`.bookingCourt__body .court`);
        let groups = [
            {
                text: 'Wszystkie',
                range: 0,
                id: 0,
            }
        ];

        let loop = 0;
        lengthCourt.each((index, item) => {
            if ($(item).hasClass('court--space')) {
                loop++;
                let range = [];
                for (let i = loop; i <= index + 1; i++) {
                    range.push(i);
                }

                let key = index + 1;
                groups[key] = {
                    text: `Korty: ${range[0]} - ${range[range.length - 1]}`,
                    range: range,
                    id: key
                };

                loop = key
            }
        });

        $('#selectBookingCourt').empty();

        groups.forEach(item => {
            let newOption = new Option(item.text, item.id, false, false);
            $('#selectBookingCourt').append(newOption);
        });

        $('#selectBookingCourt').trigger('change');

        $('#selectBookingCourt').on('select2:select', (e) => {
            let court = parseInt(e.params.data.id);

            if (court === 0) {
                lengthCourt.hide();
                $(`.bookingCourt__body .court`).fadeIn();
            } else {
                if (Boolean(groups[court])) {
                    lengthCourt.hide();
                    groups[court].range.forEach((court) => {
                        $(`.bookingCourt__body .court:nth-child(${court}`).fadeIn();
                    })
                }
            }
        });


        $('#rez_rezerwacje_div .court__input').click(function () {
            let inputsFree = $('#rez_rezerwacje_div .court__input--free:checked');
            let inputsOwn = $('#rez_rezerwacje_div .court__input--own:checked');

            let courtData = {
                ids: [],
                time: timeConvert(inputsFree.length * 30),
            };

            inputsFree.each(function (index, input) {
                let id = $(input).data().obie_id;
                if (!courtData.ids.includes(id)) {
                    courtData.ids.push(id);
                }
            });

            if (inputsFree.length) {
                modalBooking(inputsFree, 'free', courtData);
                $('#rez_rezerwacje_div .court__label--own').hide();
            }

            if (inputsOwn.length) {
                modalBooking(inputsOwn, 'own', courtData);
                $('#rez_rezerwacje_div .court__label--free').hide();
            }

            if (!inputsOwn.length && !inputsFree.length) {
                $('#rez_rezerwacje_div .court__label--own').show();
                $('#rez_rezerwacje_div .court__label--free').show();
                removeModalBooking();
            }

            $('#closeBookingModal').click(function () {
                $('#rez_rezerwacje_div .court__label--own').show();
                $('#rez_rezerwacje_div .court__label--free').show();
                $('#rez_rezerwacje_div .court__input').prop('checked', false);

                removeModalBooking();
            });
        });
    }

    function modalBooking($dataInput, $type, inputData = []) {
        let inputs = $dataInput;

        let textModal = '';
        let buttonModal = '';

        if ($type === 'free') {
            textModal = 'wolne miejsca';
            buttonModal = '<button class="modalBooking__button" id="bookingButton" type="button">' +
                'Rezerwuj <span>wybrane</span>' +
                '<i class="modalBooking__icon fas fa-arrow-right" aria-hidden="true"></i>' +
                '</button>';
        }

        if ($type === 'own') {
            textModal = 'miejsca';
            buttonModal = '<button class="modalBooking__button" id="cancelButton" type="button">' +
                'Odwołaj <span>wybrane</span>' +
                '<i class="modalBooking__icon fas fa-arrow-right" aria-hidden="true"></i>' +
                '</button>';
        }

        let config = {
            text: textModal,
            mobile: inputData,
            button: buttonModal
        };

        let courtCounter = '';

        switch (config.mobile.ids.length) {
            case 1:
                courtCounter = 'kort';
                break;
            case 2:
            case 3:
            case 4:
                courtCounter = 'korty';
                break;
            default:
                courtCounter = 'kortów';
        }

        removeModalBooking();
        if (inputs.length === 0) {
            removeModalBooking();
            return;
        }

        let numberBook = inputs.length;
        let data = [];
        inputs.each(function (index, value) {
            data.push({
                courtNumber: $(value).data('courtNumber'),
                hourStart: $(value).data('godz_od'),
            })
        });


        let dataHTML = "";
        $.each(data, function (i, item) {
            let courtNumber = item.courtNumber;
            let hourStart = item.hourStart;
            dataHTML += `Kort nr. ${courtNumber}, ${hourStart}; `;
        });

        $('#rez_rezerwacje_div').append(
            `<div class="modalBooking">
             <div class="row">
                <div class="modalBooking__field col-xs-6 d-none d-xl-block">
                    <div class="modalBooking__choose"><span>Wybrano</span></div>
                    <div class="modalBooking__court">${dataHTML}</div>
                </div>
                <div class="modalBooking__field col-xs-6 d-xl-none">
                    <div class="modalBooking__choose"><span>Wybrano</span> <b>${config.mobile.ids.length} ${courtCounter} <br> Suma czasu ${config.mobile.time} h</b></div>
                </div>
                <div class="modalBooking__field col-xs-6">
                    <div class="modalBooking__button-wrapper">
                        ${config.button}
                    </div>
                </div>
            </div>
            <div class="modalBooking__close" id="closeBookingModal"><i class="fas fa-times-circle"></i></div>
       </div>`);

        $('#bookingButton').click(function (e) {
            RezerwujWybraneShow();
            scrollToAcceptBooking(e);
        });

        $('#cancelButton').click(function () {
            OdwolajWybraneShow();
        });
    }

    function scrollToAcceptBooking(e) {
        e.preventDefault();
        $([document.documentElement, document.body]).animate({
            scrollTop: $('#div_rez').offset().top - 250,
        }, );
    }


    function removeModalBooking() {
        let modalRemove = document.querySelector('.modalBooking');
        if (modalRemove) {
            modalRemove.remove();
        }
    }

    $('#bookingLoginButton').click(function () {
        $('#bookingFormLogin').slideToggle();
    });

    if (typeof paymentStatus !== 'undefined') {
        if (paymentStatus === 'ERROR' || paymentStatus === 'PENDING' || paymentStatus === 'PERFORMED') {
            let status = '';
            switch (paymentStatus) {
                case 'ERROR':
                    status = 'płatność nie powiodła się';
                    break;
                case 'PENDING':
                    status = 'płatność oczekuje na realizację';
                    break;
                case 'PERFORMED':
                    status = 'płatność została pomyślnie zrealizowana';
                    break;
            }

            $('#rez_rezerwacje_div').append(
                `<div class="modalBooking">
         <div class="row">
            <div class="modalBooking__field col-xs-6">
                <div class="modalBooking__choose"><span>Twoja </span> <b> ${status}</b></div>
                </div>
            </div>
        <div class="modalBooking__close" id="closeBookingModal"><i class="fas fa-times-circle"></i></div>
    </div>`);
        } else if (paymentStatus === 'CLEARED') {
            $('#rez_rezerwacje_div').append(
                `<div class="modalBooking">
         <div class="row">
            <div class="modalBooking__field col-xs-6">
                <div class="modalBooking__choose"><span>Twoje zamówienie zostało poprawnie :</span> <b>zaksięgowane</b></div>
            </div>
            <div class="modalBooking__field col-xs-6">
                <div class="modalBooking__button-wrapper">
                    <a class="modalBooking__button" href="/twoje-rezerwacje" >
                        <span>Twoje rezerwacje</span>
                        <i class="modalBooking__icon fas fa-arrow-right" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
        <div class="modalBooking__close" id="closeBookingModal"><i class="fas fa-times-circle"></i></div>
    </div>`);
        }
    }


    $('#closeBookingModal').click(function () {
        removeModalBooking();
    });

    function timeConvert(n) {
        var num = n;
        var hours = (num / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        return rhours + ':' + rminutes;
    }

    if (document.querySelector('.page-template-Booking')){
        window.addEventListener("pageshow", function (event) {
            const historyTraversal = event.persisted || (typeof window.performance != "undefined" && performance.navigation.type === 2);
            if (historyTraversal) {
                ShowRezerwacjeTable();
            }
        });
    }

})(jQuery);
